import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classnames from 'classnames';
import useConfig from '../../../hooks/useConfig';
var defaultBgColor = 'rgba(0,0,0,0.8)';
var cls = 'gesture-title';
var GestureTitle = function GestureTitle(_ref) {
  var config = _ref.config,
    id = _ref.id,
    _onClick = _ref.onClick,
    render = _ref.render,
    className = _ref.className,
    pid = _ref.pid;
  var bgColor = config.bgColor,
    deeplink = config.deeplink,
    link = config.link,
    textClor = config.textClor,
    title = config.title,
    rightText = config.rightText;
  var _useConfig = useConfig(),
    createNamespace = _useConfig.createNamespace,
    prefixCls = _useConfig.prefixCls;
  var classes = classnames(createNamespace === null || createNamespace === void 0 ? void 0 : createNamespace(cls, prefixCls), className, textClor);
  return _jsxs("div", Object.assign({
    style: {
      backgroundColor: bgColor || defaultBgColor
    },
    onClick: function onClick() {
      return _onClick === null || _onClick === void 0 ? void 0 : _onClick({
        render: render,
        componentId: id,
        pid: pid,
        link: link,
        deeplink: deeplink
      });
    },
    className: classes,
    "data-pid": pid,
    "data-componentid": id
  }, {
    children: [_jsx("div", Object.assign({
      className: classnames(createNamespace === null || createNamespace === void 0 ? void 0 : createNamespace(cls + "-left", prefixCls))
    }, {
      children: title
    })), _jsxs("div", Object.assign({
      className: classnames(createNamespace === null || createNamespace === void 0 ? void 0 : createNamespace(cls + "-right", prefixCls))
    }, {
      children: [_jsx("span", {
        children: rightText
      }), _jsx("span", Object.assign({
        className: classnames(createNamespace === null || createNamespace === void 0 ? void 0 : createNamespace(cls + "-arraw", prefixCls))
      }, {
        children: '>'
      }))]
    }))]
  }));
};
GestureTitle.defaultProps = {
  config: {}
};
GestureTitle.displayName = 'GestureTitle';
export default GestureTitle;